const $Body = $('#js-body');

export default $Body;